import { createFileRoute } from '@tanstack/react-router'
import { WebhookDeliveryPage } from '../features/developer/WebhookDeliveryPage'

export const Route = createFileRoute('/_auth/developer/webhooks/$webhookId/deliveries')({
  component: function WebhookDeliveryRoute() {
    const { webhookId } = Route.useParams()
    return <WebhookDeliveryPage webhookId={Number(webhookId)} />
  },
})
